import { UserTier } from '@/entities/permissions/types';
import type { UserSubscription } from '@/types/auth';

export const resolveUserTier = (
  subscription: UserSubscription | null,
  isExpired: boolean
): UserTier => {
  if (!subscription) return UserTier.Public;
  if (isExpired) return UserTier.Expired;
  const normalizedPlan = subscription.plan.trim().toLowerCase();

  if (subscription.trial) {
    return normalizedPlan === 'premium' ? UserTier.TrialPremium : UserTier.TrialBasic;
  }
  if (normalizedPlan !== 'premium') return UserTier.Basic;
  if (subscription.apiAccess === false) return UserTier.PremiumNoApi;

  return UserTier.Premium;
};
